export default __webpack_public_path__ + "static/media/investment-philosophy.2bca4f07.jpg";